export default "__VITE_ASSET__DfvTbsq1__"